module.exports = __webpack_public_path__ + "static/img/3.f72cd53.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/4/zh/3.png
// module id = fG6Q
// module chunks = 0